import { Link, Route } from "react-router-dom";
import LoginLayout from "../themes/Login/LoginLayout";
import { Login } from "../pages";

const LoginRoutes = () => {
  return (
    <Route path="/" element={<LoginLayout />}>
      <Route index element={<Login />} />
    </Route>
  );
};

export default LoginRoutes;
